import React, { useState, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { brandTextLogo } from '../../utils/brandLogos';
import './styles.css';
import { useNavigate } from 'react-router-dom';
import { useFormik } from "formik";
import * as Yup from "yup";
//import PythonShell from 'python-shell';

import { useLocation } from 'react-router-dom';
//import { importCardapioAnotaai, importCardapioIfood } from '../../services/api';
import { trackEvent } from '../../utils/facebookPixel';

// Hook para detectar mobile
function useIsMobile() {
    const [isMobile, setIsMobile] = React.useState(window.innerWidth <= 600);
    React.useEffect(() => {
        const onResize = () => setIsMobile(window.innerWidth <= 600);
        window.addEventListener('resize', onResize);
        return () => window.removeEventListener('resize', onResize);
    }, []);
    return isMobile;
}

const IntegracaoCardapio = () => {
    const { t } = useTranslation(['auth', 'common']);
    const location = useLocation();
    const { infoEmpresaObj, passwordObj, linkObj } = location.state || {};
    //process.env.REACT_APP_ISDEVELOP === 'true' && console.log(infoEmpresaObj, passwordObj);

    const navigate = useNavigate();
    const [optSelected, setOptSelected] = useState('import');
    const [onIfoodAndAnotaai, setOnIfoodAndAnotaai] = useState(linkObj ? linkObj.onIfoodAndAnotaai : '');
    const [importType, setImportType] = useState(linkObj ? linkObj.importType : '');
    const [hasVideo, setHasVideo] = useState(false);
    const isMobile = useIsMobile();

    useEffect(() => {
        if (window.fbq) {
            trackEvent('CadastroCardapio', {
                step: 'integracao_cardapio'
            });
        }
    }, []);

    const handleOptSelected = (opt) => {
        setOptSelected(opt);
        if (opt === "info") {
            navigate("/informacoes", { state: { infoEmpresaObj, passwordObj, linkObj } });
        }
        if (opt === "credential") {
            navigate("/credenciais", { state: { infoEmpresaObj, passwordObj, linkObj } });
        }

    }

    const handleBack = () => {
        navigate("/credenciais", { state: { infoEmpresaObj, passwordObj, linkObj } });
    }

    //Validações
    const SignUpSchema = Yup.object().shape({
        ifoodLink: importType === 'linkIfood' && Yup.string().required(t('common:validation.required')),
        anotaAiLink: importType === 'linkAnotaAi' && Yup.string().required(t('common:validation.required')),
    });

    const formik = useFormik({
        validationSchema: SignUpSchema,
        validateOnBlur: false,
        validateOnChange: false,
        //enableReinitialize: true,
        initialValues: {
            ifoodLink: linkObj && linkObj.importType === "linkIfood" ? linkObj.importLink : "",
            anotaAiLink: linkObj && linkObj.importType === "linkAnotaAi" ? linkObj.importLink : "",
        },
        onSubmit: (values) => {

            //const password = values.password;
            //const confirmPassword = values.confirmPassword;
            const ifoodLink = values.ifoodLink;
            const anotaAiLink = values.anotaAiLink

            //handleSubmitAPI();   
            if (importType === 'linkIfood') {
                //importaCardapioIfood(ifoodLink)
                const linkObj = {
                    onIfoodAndAnotaai: onIfoodAndAnotaai,
                    importType: 'linkIfood',
                    importLink: ifoodLink
                }
                //importCardapioIfood(ifoodLink, 2);
                navigate("/endereco", { state: { infoEmpresaObj, passwordObj, linkObj } });
            } else if (importType === 'linkAnotaAi') {
                //importaCardapioAnotaai(anotaAiLink)
                const linkObj = {
                    onIfoodAndAnotaai: onIfoodAndAnotaai,
                    importType: 'linkAnotaAi',
                    importLink: anotaAiLink
                }
                //importCardapioAnotaai(anotaAiLink, 2);
                navigate("/endereco", { state: { infoEmpresaObj, passwordObj, linkObj } });
            }

        },
    });

    const handleNoImport = () => {
        setOnIfoodAndAnotaai('nao')
        setOptSelected('endereco');
        navigate("/endereco", { state: { infoEmpresaObj, passwordObj, linkObj } });
    }

    return (
        <div className='containerAddEmpresa'>
            <div className='divSidePanel'>
                <div className='divSidePanelContent'>
                    <div className='divLogo'>
                        <img width={140} height={42} src={brandTextLogo} alt='Logo' />
                    </div>
                    <div className='divMenu'>
                        <div className='divMenuItem'>
                            <div style={{ display: 'flex', flexDirection: 'row' }}>
                                {optSelected === "info" ? <div className='menuItemSelected' /> : null}
                                <p className={optSelected === "info" ? 'btnOptionsAddEmpresa checked' : "btnOptionsAddEmpresa"} onClick={() => handleOptSelected("info")}>{t('auth:register.sidebarStep1')}</p>
                            </div>
                            <div style={{ display: 'flex', flexDirection: 'row' }}>
                                {optSelected === "credential" ? <div className='menuItemSelected' /> : null}
                                <p className={optSelected === "credential" ? 'btnOptionsAddEmpresa checked' : "btnOptionsAddEmpresa"} onClick={() => handleOptSelected("credential")}>{t('auth:register.sidebarStep2')}</p>
                            </div>
                            <div style={{ display: 'flex', flexDirection: 'row' }}>
                                {optSelected === "import" ? <div className='menuItemSelected' /> : null}
                                <p className={optSelected === "import" ? 'btnOptionsAddEmpresa checked' : "btnOptionsAddEmpresa"} onClick={() => handleOptSelected("import")}>{t('auth:register.address.sidebarStep3')}</p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>



            <div className="containerAddEmpresaForm">
                <form onSubmit={formik.handleSubmit} className="formAddEmpresa">

                    <div className='informationsAccount'>

                        <div style={{
                            fontFamily: 'Arial, sans-serif',
                            padding: isMobile ? '10px' : '20px',
                            backgroundColor: 'white',
                            color: '#333',
                            margin: 'auto',
                            boxSizing: 'border-box',
                            width: '100%',
                            maxWidth: isMobile ? '100%' : '500px',
                        }}>
                            <h3>{t('auth:integration.ifoodAnotaaiQuestion')}</h3>
                            <p>{t('auth:integration.ifoodAnotaaiDescription')}</p>
                            <div style={{
                                display: 'flex',
                                flexDirection: isMobile ? 'column' : 'row',
                                gap: '10px',
                                marginBottom: '20px',
                            }}>
                                <button type="button"
                                    className={onIfoodAndAnotaai === 'sim' ? 'btnFwdCadastros' : 'btnBackCadastros'}
                                    onClick={() => setOnIfoodAndAnotaai('sim')}
                                    style={{ width: isMobile ? '100%' : '50%' }}>
                                    {t('common:messages.yes')}
                                </button>
                                <button type="button"
                                    className={onIfoodAndAnotaai === 'nao' ? 'btnFwdCadastros' : 'btnBackCadastros'}
                                    onClick={() => handleNoImport()}
                                    style={{ width: isMobile ? '100%' : '50%' }}>
                                    {t('common:messages.no')}
                                </button>
                            </div>
                            {
                                onIfoodAndAnotaai === 'sim' ?
                                    <div>
                                        <div>
                                            <h3>{t('auth:integration.importMenuQuestion')}</h3>
                                            <div style={{ display: 'flex', flexDirection: 'column', gap: '10px', marginBottom: '20px' }}>
                                                <button type="button"
                                                    className={importType === 'linkIfood' ? 'btnFwdCadastros' : 'btnBackCadastros'}
                                                    style={{ width: '100%' }} onClick={() => setImportType('linkIfood')}>
                                                    {t('auth:integration.byIfoodLink')}
                                                </button>
                                                <button type="button"
                                                    className={importType === 'linkAnotaAi' ? 'btnFwdCadastros' : 'btnBackCadastros'}
                                                    style={{ width: '100%' }} onClick={() => setImportType('linkAnotaAi')}>
                                                    {t('auth:integration.byAnotaaiLink')}
                                                </button>
                                                <button className='btnBackCadastros' style={{ width: '100%' }}>{t('auth:integration.dontWantImport')}</button>
                                            </div>
                                        </div>
                                        {
                                            importType === 'linkIfood' ?
                                                <div>
                                                    <h3>{t('auth:integration.pasteIfoodLink')}</h3>
                                                    <p style={{ marginBottom: '5px', textDecoration: 'underline', color: '#007bff', cursor: 'pointer' }} onClick={() => setHasVideo(true)}>{t('auth:integration.whereIfoodLink')}</p>
                                                    {hasVideo ?
                                                        <div>
                                                            <p style={{ marginBottom: '20px' }}>{t('auth:integration.learnCopyIfoodLink')}</p>
                                                            <div style={{ marginBottom: '20px', display: 'flex', justifyContent: 'center' }}>
                                                                <div style={{ position: 'relative', width: isMobile ? '100%' : '560px', paddingBottom: isMobile ? '56.25%' : undefined, height: isMobile ? 0 : '315px' }}>
                                                                    <iframe
                                                                        title="Tutorial iFood - Como copiar link do cardápio"
                                                                        src="https://www.youtube.com/embed/example"
                                                                        allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                                                                        allowFullScreen
                                                                        style={{
                                                                            position: isMobile ? 'absolute' : 'static',
                                                                            top: 0,
                                                                            left: 0,
                                                                            width: isMobile ? '100%' : '560px',
                                                                            height: isMobile ? '100%' : '315px',
                                                                        }}
                                                                    ></iframe>
                                                                </div>
                                                            </div>
                                                            <button className='btnBackCadastros' style={{ width: '100%', marginBottom: '10px' }} onClick={() => setHasVideo(false)}>{t('auth:integration.closeVideo')}</button>
                                                        </div>
                                                        : null
                                                    }
                                                    <div style={{ display: 'flex', flexDirection: 'column', gap: '10px', marginBottom: '20px' }}>
                                                        <label htmlFor="ifoodLink">{t('auth:integration.ifoodMenuLink')}</label>
                                                        <input type="text"
                                                            id="ifoodLink"
                                                            name="ifoodLink"
                                                            value={formik.values.ifoodLink}
                                                            onChange={formik.handleChange}
                                                            style={{ padding: '10px', border: '1px solid #ccc', width: '100%', boxSizing: 'border-box' }}
                                                            className='linkToImportInput'
                                                            placeholder="https://www.ifood.com.br/delivery/cidade-uf/loja-exemplo-setor-exemplo/..." />
                                                        {formik.errors.ifoodLink && (
                                                            <div className="error">{formik.errors.ifoodLink}</div>
                                                        )}
                                                    </div>
                                                    <div style={{
                                                        display: 'flex',
                                                        flexDirection: isMobile ? 'column' : 'row',
                                                        gap: '10px',
                                                    }}>
                                                        <button type="button" className='btnBackCadastros' style={{ width: isMobile ? '100%' : '50%' }} onClick={() => handleBack()}>{t('common:buttons.back')}</button>
                                                        <button type="submit" className='btnFwdCadastros' style={{ width: isMobile ? '100%' : '50%' }}>{t('common:buttons.next')}</button>
                                                    </div>
                                                </div>
                                                : importType === 'linkAnotaAi' &&
                                                <div>
                                                    <h3>{t('auth:integration.pasteAnotaaiLink')}</h3>
                                                    <p style={{ marginBottom: '5px', textDecoration: 'underline', color: '#007bff', cursor: 'pointer' }} onClick={() => setHasVideo(true)}>{t('auth:integration.whereAnotaaiLink')}</p>
                                                    {hasVideo ?
                                                        <div>
                                                            <p style={{ marginBottom: '20px' }}>{t('auth:integration.learnCopyAnotaaiLink')}</p>
                                                            <div style={{ marginBottom: '20px', display: 'flex', justifyContent: 'center' }}>
                                                                <div style={{ position: 'relative', width: isMobile ? '100%' : '560px', paddingBottom: isMobile ? '56.25%' : undefined, height: isMobile ? 0 : '315px' }}>
                                                                    <iframe
                                                                        title="Tutorial AnotaAi - Como copiar link do cardápio"
                                                                        src="https://www.youtube.com/embed/example"
                                                                        allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                                                                        allowFullScreen
                                                                        style={{
                                                                            position: isMobile ? 'absolute' : 'static',
                                                                            top: 0,
                                                                            left: 0,
                                                                            width: isMobile ? '100%' : '560px',
                                                                            height: isMobile ? '100%' : '315px',
                                                                        }}
                                                                    ></iframe>
                                                                </div>
                                                            </div>
                                                            <button className='btnBackCadastros' style={{ width: '100%', marginBottom: '10px' }} onClick={() => setHasVideo(false)}>{t('auth:integration.closeVideo')}</button>
                                                        </div>
                                                        : null
                                                    }
                                                    <div style={{ display: 'flex', flexDirection: 'column', gap: '10px', marginBottom: '20px' }}>
                                                        <label htmlFor="anotaAiLink">{t('auth:integration.anotaaiMenuLink')}</label>
                                                        <input type="text"
                                                            id="anotaAiLink"
                                                            name="anotaAiLink"
                                                            value={formik.values.anotaAiLink}
                                                            onChange={formik.handleChange}
                                                            style={{ padding: '10px', border: '1px solid #ccc', width: '100%', boxSizing: 'border-box' }}
                                                            className='linkToImportInput'
                                                            placeholder="https://pedido.anota.ai/loja/nome-da-loja-1?f=msa" />
                                                        {formik.errors.anotaAiLink && (
                                                            <div className="error">{formik.errors.anotaAiLink}</div>
                                                        )}
                                                    </div>
                                                    <div style={{
                                                        display: 'flex',
                                                        flexDirection: isMobile ? 'column' : 'row',
                                                        gap: '10px',
                                                    }}>
                                                        <button type="button" className='btnBackCadastros' style={{ width: isMobile ? '100%' : '50%' }}>{t('common:buttons.back')}</button>
                                                        <button type="submit" className='btnFwdCadastros' style={{ width: isMobile ? '100%' : '50%' }}>{t('common:buttons.next')}</button>
                                                    </div>
                                                </div>
                                        }


                                    </div>
                                    :
                                    null
                            }

                        </div>

                    </div>

                </form>
            </div>





        </div>
    );
}

export default IntegracaoCardapio;

